import {customElement, queryAll} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {ContentSearchImages} from "../contentSearchImages";
import {resolve} from "../../../../container";
import {keyed} from "lit/directives/keyed.js";
import type {FeedEntryTopic} from "../../feedEntry";
import {SearchTile} from "../searchTile";
import type {Nullable} from "../../../../bootstrap/common/types";
import {EopNewsSearchResultsTileTag} from "./newsSearchResultsTileTag";

@customElement("eop-news-search-results-tile")
export class EopNewsSearchResultsTile extends SearchTile {

    @queryAll("eop-news-search-results-tile-tag")
    private tags: NodeListOf<EopNewsSearchResultsTileTag>;

    public constructor(private images: ContentSearchImages = resolve(ContentSearchImages)) {
        super();
    }

    public render(): TemplateResult {
        return html`${keyed(this.entry.data.url + this.groupName, this.renderTile())}`;
    }

    protected renderImageElement(): Nullable<TemplateResult> {
        const functionalIcons = (!!this.entry.data.lightboxImageUrl && !this.entry.data.disclaimer) ? "lightbox-image-preview-icon" : "";
        return this.images.imageWithStaticAspectRatio(this.entry.getImageUrlFor4x3Purpose(), this.entry.data.imageAltText, functionalIcons);
    }

    protected renderTopicLinks(): Nullable<TemplateResult> {
        const feedEntryTopics = this.entry.data.topics;
        if (!feedEntryTopics || feedEntryTopics.isEmpty()) {
            return null;
        }

        return html`
            <div class="tags">${(this.renderTopicTags(feedEntryTopics))}</div>`;
    }

    private renderTopicTags(feedEntryTopics: FeedEntryTopic[]): TemplateResult[] {
        return feedEntryTopics.map(topic => html`
            <eop-news-search-results-tile-tag
                    @mouseover=${this.removeHoverClass}
                    @mouseout=${this.addHoverClass}
                    .text=${topic.name}>
            </eop-news-search-results-tile-tag>
        `);
    }

    protected showDescription(): boolean {
        return true;
    }

    protected headlineText(): string {
        return this.entry.data.headline ?? "---";
    }

    protected subHeadlineText(): string {
        return this.entry.data.subHeadline ?? "";
    }

    public lastFocusable(): HTMLElement {
        return Array.from(this.tags).lastElement()?.focusableElement()
            ?? this.lastFocusableLink()
            ?? this.focusableTile();
    }
}